<template>
  <div class="canvas-controls">
    <div class="buttons">
      <button
        class="button secondary"
        :class="modeActiveClass('layers')"
        @click="modeToggle('layers')"
      >
        <i class="fa fa-layer-group" />
      </button>
      <button
        class="button secondary"
        :class="modeActiveClass('stencil')"
        v-if="smtPadCount > 0"
        @click="modeToggle('stencil')"
      >
        Stencil
      </button>
      <button class="button secondary" @click="changeSide">
        <i class="fa fa-sync" />
      </button>
      <button class="button secondary" @click="measureToolHint">
        <i class="fa fa-ruler" />
      </button>
    </div>
    <div class="layers" v-if="mode === 'layers'">
      <h3>{{ sideActive }}</h3>
      <span
        v-for="layer in this.layers"
        :key="layer.name"
        class="toggler align"
        :class="{ active: layer.selected }"
        @click="toggleLayer(layer)"
      >
        <input type="checkbox" v-model="layer.selected">
        <span class="indicator" :style="layer.indicator" />
        <span>{{ layer.title }}</span>
        <br>
      </span>
    </div>
  </div>
</template>

<script>
import * as PcbStackup from 'helper/pcb_stackup';
import * as PcbMaterials from 'helper/pcb_materials';
import { components } from 'locales';

export default {
  name: 'BoardInspectorControls',
  props: {
    stackupViewPreset: String,
    smtPadCount: String,
  },
  data() {
    return {
      bus: this.$root.bus,
      mode: 'preview',
      spin: false,
      layers: [],
    };
  },
  computed: {
    sideActive() {
      return this.spin ? this.$t('back') : this.$t('front');
    },
  },
  mounted() {
    this.initLayerSelector();
  },
  methods: {
    modeActiveClass(mode) {
      return this.mode === mode ? 'active' : '';
    },
    modeToggle(mode) {
      this.mode = this.mode === mode ? 'preview' : mode;
      this.bus.emit('modeToggle', this.mode);
      this.initLayerSelector();
    },
    changeSide() {
      this.spin = !this.spin;
      this.iso = false;
      if (this.spin) {
        this.bus.emit('changePerspective', 'back');
      } else {
        this.bus.emit('changePerspective', 'front');
      }
    },
    toggleLayer(layer) {
      layer.selected = !layer.selected;
      this.bus.emit('updateShape', { shape: layer.name, value: layer.selected });
    },
    measureToolHint() {
      this.$root.message = this.$t('measureHint');
    },
    initLayerSelector() {
      const self = this;
      this.layers = PcbStackup[this.stackupViewPreset].map((layer) => {
        if (layer.name.includes('toplayer') || layer.name.includes('bottomlayer') || layer.name.includes('internalplane')) {
          return {
            name: layer.name,
            title: self.$t(layer.name),
            selected: true,
            indicator: `background-color: #${PcbMaterials.layout[layer.name].color.getHexString()}`,
          };
        }
        return false;
      }).filter((layer) => layer);
    },
  },
  i18n: components.BoardInspectorControls,
};
</script>

<style scoped lang="scss">
.canvas-controls {
  position: absolute;
  top: 0px;
  margin-top: 1.5rem;
  margin-left: 1.5rem;
}

.buttons {
  button {
    margin: 0 2px;
  }
}

.layers {
  color: #ffffff;
  font-size: 1rem;
  font-weight: 600;
  float: left;
}

.toggler {
  cursor: pointer;
  line-height: 1;
  -webkit-appearance: none;
  font-weight: 400;

  &.active {
    font-weight: 600;
  }

  input {
    margin: 0 0 0.5rem;
  }

  span.indicator {
    height: 1rem;
    width: 1rem;
    display: inline-block;
    margin: 0 0.5rem;
    transform: translateY(3px);
  }
}
</style>
